export default __webpack_public_path__ + "static/img-ld-capital-b8f64f4d4e2d55baa2cab71aeb0e8c71.png";